import SideBar from '../../containers/SideBar'
import Formulary from '../../containers/Formulary'

const Register = () => (
  <>
    <SideBar showFilteredResults={false} />
    <Formulary />
  </>
)

export default Register
